'use strict';

var cov_r4dez7y6q = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.economic.activities.factory.js',
        hash = '4e2229520041a3443e635b7293a0d2cdf2b2ed2c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocomplete.economic.activities.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 84
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_r4dez7y6q.s[0]++;
(function () {
    'use strict';

    cov_r4dez7y6q.f[0]++;
    cov_r4dez7y6q.s[1]++;
    angular.module('app').factory('OrganizationAutocompleteEconomicActivitiesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_r4dez7y6q.f[1]++;
        cov_r4dez7y6q.s[2]++;

        return restmod.model('/organization-autocomplete-economic-activities').mix('MixinContainable', {
            $config: {
                contains: {
                    economicActivity: {
                        type: 'belongsTo',
                        table: 'EconomicActivitiesTable',
                        foreignKey: 'economicActivity'
                    }
                }
            }
        });
    }
})();